export default "__VITE_ASSET__LWi6AoWC__"